import { render, staticRenderFns } from "./Slot.vue?vue&type=template&id=287ebdee&scoped=true&"
import script from "./Slot.vue?vue&type=script&lang=js&"
export * from "./Slot.vue?vue&type=script&lang=js&"
import style0 from "./Slot.vue?vue&type=style&index=0&id=287ebdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ebdee",
  null
  
)

export default component.exports